const poundConversion = (val) => {
  return `${val} lbs`;
};

export default poundConversion;
